import {cloneElement} from 'react'

// One visual language for both providers: color means cloudiness, not job state.
const ImageCalendarDay = ({inCurrentMonth, cloudState, active, title, ariaLabel, children}) => {
  if (!inCurrentMonth) return children
  const colorClass = {clear: 'date-with-data', cloudy: 'date-with-cloud', unknown: 'is-cloud-unknown'}[cloudState] || ''
  return <div className={`view-land-calendar-day ${colorClass} ${active ? 'active' : ''}`.trim()} title={title}>
    {ariaLabel ? cloneElement(children, {'aria-label': ariaLabel}) : children}
  </div>
}

export default ImageCalendarDay
